import { Image } from '@cian/ui-kit';
import { Agent24, User24 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';

export enum EUserCardAvatarType {
  Agent = 'agent',
  User = 'user',
}

type TUserCardAvatar = {
  src?: string | null;
  type: EUserCardAvatarType;
};

export const UserCardAvatar: React.VFC<TUserCardAvatar> = ({ src, type }) => {
  return (
    <div className={styles['container']} data-testid="UserCardAvatar">
      {src ? (
        <div className={styles['image']}>
          <Image
            src={src}
            alt="Фотография пользователя"
            borderRadius={'50%'}
            objectFit="contain"
            theme="light"
            height={80}
            width={80}
            preloader
          />
        </div>
      ) : (
        <div className={styles['icon']}>
          {type === 'agent' ? (
            <span className={styles['icon_agent']}>
              <Agent24 color="current_color" />
            </span>
          ) : (
            <span className={styles['icon_user']}>
              <User24 color="current_color" />
            </span>
          )}
        </div>
      )}
    </div>
  );
};
